<template>
  <v-container>
    <h1 class="mt-10 mb-5">{{ $t('nav.contact') }}</h1>
    <v-row>
      <v-col cols="12" md="6">
        <div class="item-body" style="padding-right: 30px;">
          <h3>办公地址</h3>
          <span>上海市浦东新区东方路818号众城大厦14H</span>
          <div style="height: 80px;" />
          <h3>联系方式</h3>
          <p><v-icon color="blue">mdi-phone</v-icon>电话：021-50917571</p>
          <p><v-icon color="green">mdi-wechat</v-icon>微信：13564896570</p>
          <p><v-icon color="orange">mdi-email</v-icon>邮箱：info@shundacpa.com</p>
        </div>
      </v-col>
      <v-col cols="12" md="6">
        <v-img src="/assets/img/GGI3_kigmzskigmzskigm.png" alt="Illustration" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Contact',
}
</script>

<style scoped>
.item-body {
  width: 100%;
  padding-top: 10px;
  padding-bottom: 30px;
}

.item-body h3 {
  padding-top: 10px;
  padding-bottom: 10px;
}

.item-body p {
  line-height: 2;
}
</style>